import React from "react"

export const marks = {
  1: {
    label: <>Not at all</>,
  },
  5: {
    label: <>Very</>,
  },
}